import { AKCENTY, useMotyw, type Akcent, type Preferencja } from "../motyw.ts";
import { Ekran, Karta, Przycisk } from "../ui.tsx";

const MOTYWY: Array<[Preferencja, string]> = [
  ["auto", "Auto"],
  ["jasny", "Jasny"],
  ["ciemny", "Ciemny"],
];

/**
 * Opcje wyglądu.
 *
 * Osobny ekran, nie kafelek na liście partii: ustawienia ogląda się raz na
 * kilka tygodni, a lista partii jest tym, po co aplikację się otwiera. Kafelek
 * odsuwałby w dół rzecz oglądaną codziennie na rzecz rzeczy oglądanej rzadko.
 */
export function Opcje({
  onWroc,
  onKonta,
  onStatystyki,
  onWyloguj,
}: {
  onWroc: () => void;
  /** Tylko dla administratora — inaczej `undefined` i wiersz się nie pokazuje. */
  onKonta?: (() => void) | undefined;
  onStatystyki: () => void;
  onWyloguj: () => void;
}) {
  const { pref, akcent, ustaw, ustawAkcent } = useMotyw();

  return (
    <Ekran
      tytul="Opcje"
      akcja={
        <Przycisk wariant="cichy" onClick={onWroc}>
          Wróć
        </Przycisk>
      }
    >
      <Karta>
        <div>Motyw</div>
        <div className="text-sm text-tekst-slaby">Auto idzie za trybem nocnym telefonu</div>
        <div className="mt-3 grid grid-cols-3 gap-2">
          {MOTYWY.map(([wartosc, etykieta]) => (
            <button
              key={wartosc}
              onClick={() => ustaw(wartosc)}
              aria-pressed={pref === wartosc}
              className={[
                "min-h-10 rounded-xl border text-sm transition-colors",
                pref === wartosc
                  ? "bg-akcent border-akcent text-tlo"
                  : "bg-panel-jasny border-obrys text-tekst-slaby",
              ].join(" ")}
            >
              {etykieta}
            </button>
          ))}
        </div>
      </Karta>

      <Karta>
        <div>Kolor</div>
        <div className="text-sm text-tekst-slaby">Będzie też kolorem twojego pionka</div>
        <div className="mt-3 grid grid-cols-3 gap-2">
          {AKCENTY.map(([wartosc, etykieta]) => (
            <ProbkaKoloru
              key={wartosc}
              wartosc={wartosc}
              etykieta={etykieta}
              wybrany={akcent === wartosc}
              onWybierz={() => ustawAkcent(wartosc)}
            />
          ))}
        </div>
      </Karta>

      <Karta onClick={onStatystyki}>
        <div>Statystyki</div>
        <div className="text-sm text-tekst-slaby">Bilans, rekordy i historia partii</div>
      </Karta>

      {onKonta ? (
        <Karta onClick={onKonta}>
          <div>Konta</div>
          <div className="text-sm text-tekst-slaby">Zaproszenia i resety haseł</div>
        </Karta>
      ) : null}

      <Przycisk wariant="zwykly" pelna onClick={onWyloguj}>
        Wyjdź
      </Przycisk>
    </Ekran>
  );
}

/**
 * Zaznaczenie idzie obrysem, nie „ptaszkiem" w środku.
 *
 * Znaczek w kółku zasłania barwę, którą właśnie się ocenia — a przy grafitowym
 * i brązowym różnica jest na tyle mała, że każdy przesłonięty kawałek boli.
 */
function ProbkaKoloru({
  wartosc,
  etykieta,
  wybrany,
  onWybierz,
}: {
  wartosc: Akcent;
  etykieta: string;
  wybrany: boolean;
  onWybierz: () => void;
}) {
  return (
    <button
      onClick={onWybierz}
      aria-pressed={wybrany}
      className="flex flex-col items-center gap-1.5 py-1"
    >
      <span
        className={[
          "block w-full h-10 rounded-xl border-2 transition-colors",
          `probka-${wartosc}`,
          wybrany ? "border-tekst" : "border-obrys",
        ].join(" ")}
      />
      <span className={`text-xs ${wybrany ? "text-tekst" : "text-tekst-slaby"}`}>{etykieta}</span>
    </button>
  );
}
